export default __webpack_public_path__ + "static/media/v7.4a914be0.svg";